export default __webpack_public_path__ + "static/FoundersGrotesk-Medium-8501130b7e51f9836d51fe51f5333275.otf";